package nl.staartvin.solarpower.data.net

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.engine.js.Js

/**
 * `actual` for [httpClient] on Kotlin/JS (browser). Uses the `Js` engine,
 * which is a thin wrapper over the browser's `fetch`. Because it rides on
 * `fetch`, requests are subject to the browser's same-origin / CORS policy —
 * which is why the web build points the API base URLs at same-origin paths
 * that Nginx Proxy Manager forwards to the real upstreams.
 */
actual fun httpClient(block: HttpClientConfig<*>.() -> Unit): HttpClient =
    HttpClient(Js) {
        block()
    }
